import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { DropdownItemSpec } from 'core/elements/dropdown/DropdownCommonProps'
import MultiDropdown, { MultiDropdownProps } from 'core/elements/dropdown/MultiDropdown'
import useListAction from 'core/hooks/useListAction'
import { listClusterHostGroups } from './actions'
import { clusterHostGroupsSelector } from './selectors'

interface Props extends Omit<MultiDropdownProps<string>, 'items'> {
  disableClusterWithoutHosts?: boolean
  filterFn?: (item: any) => boolean
  optionMapFn?: (value: any) => DropdownItemSpec<string>
}

export default function ClusterHostGroupsMultiPicklist({
  disableClusterWithoutHosts = false,
  filterFn,
  optionMapFn,
  ...rest
}: Props) {
  const { loading } = useListAction(listClusterHostGroups)
  const clusterHostGroups = useSelector(clusterHostGroupsSelector)

  const items = useMemo(() => {
    const filteredHostGroups = filterFn ? clusterHostGroups.filter(filterFn) : clusterHostGroups
    const mapFn = optionMapFn
      ? optionMapFn
      : (clusterHostGroup) => {
          const disabled = disableClusterWithoutHosts && clusterHostGroup.hosts?.length === 0
          return {
            label: `${clusterHostGroup.name}${disabled ? ' (No Hosts Assigned)' : ''}`,
            value: clusterHostGroup.name,
            disabled,
          }
        }
    return filteredHostGroups.map(mapFn).sort((a, b) => {
      if (a.disabled && !b.disabled) return 1
      if (!a.disabled && b.disabled) return -1
      return 0
    })
  }, [clusterHostGroups, disableClusterWithoutHosts, filterFn, optionMapFn])

  return <MultiDropdown items={items} loading={loading} {...rest} />
}
